var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.83527C14.8752 8.83527 15.7146 8.47044 16.3334 7.82104C16.9523 7.17165 17.3 6.29091 17.3 5.37253C17.3 4.45415 16.9523 3.57334 16.3334 2.92395C15.7146 2.27456 14.8752 1.90973 14 1.90973",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 12.5919C16.0807 12.6305 16.6189 12.7112 17.1491 12.8332C17.5442 12.8631 17.9282 12.9839 18.2739 13.187C18.6195 13.3901 18.9183 13.6706 19.1491 14.0084C19.248 14.2283 19.2993 14.4683 19.2993 14.7114C19.2993 14.9545 19.248 15.1947 19.1491 15.4145C18.9183 15.7524 18.6195 16.0328 18.2739 16.2359C17.9282 16.439 17.5442 16.5598 17.1491 16.5898",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59003 13.3368C11.28 13.3368 14.43 13.9245 14.43 16.2645C14.43 18.6044 11.3 19.213 7.59003 19.213C3.88003 19.213 0.75 18.6359 0.75 16.2854C0.75 13.9349 3.88003 13.3368 7.59003 13.3368Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58924 9.98951C6.72056 9.98951 5.87139 9.71908 5.14924 9.21245C4.42709 8.70581 3.86439 7.98574 3.53242 7.1434C3.20045 6.30106 3.11411 5.37432 3.28431 4.48046C3.45451 3.5866 3.87364 2.76581 4.4886 2.12199C5.10355 1.47818 5.88667 1.04032 6.7389 0.86376C7.59114 0.687203 8.47414 0.779923 9.27613 1.13019C10.0781 1.48045 10.763 2.07251 11.2442 2.83142C11.7254 3.59034 11.9812 4.48197 11.9792 5.39349V5.39349C11.9805 5.99567 11.8688 6.59223 11.6504 7.1491C11.432 7.70597 11.1112 8.21227 10.7064 8.63905C10.3015 9.06583 9.82047 9.40477 9.29078 9.63649C8.76109 9.86821 8.19309 9.98813 7.61921 9.98951H7.58924Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.a923d72eb03b5823aef9d2645bfd07dd.svg";
export { ForwardRef as ReactComponent };